var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 20H26.4C24.1598 20 23.0397 20 22.184 20.436C21.4314 20.8195 20.8195 21.4314 20.436 22.184C20 23.0397 20 24.1598 20 26.4V37.6C20 39.8402 20 40.9603 20.436 41.816C20.8195 42.5686 21.4314 43.1805 22.184 43.564C23.0397 44 24.1598 44 26.4 44H38.6667C39.9066 44 40.5266 44 41.0353 43.8637C42.4156 43.4938 43.4938 42.4157 43.8637 41.0353C44 40.5266 44 39.9066 44 38.6667M41.3333 26.6667V18.6667M37.3333 22.6667H45.3333M30 27.3333C30 28.8061 28.8061 30 27.3333 30C25.8606 30 24.6667 28.8061 24.6667 27.3333C24.6667 25.8606 25.8606 24.6667 27.3333 24.6667C28.8061 24.6667 30 25.8606 30 27.3333ZM35.9867 31.8909L24.7082 42.1441C24.0738 42.7208 23.7566 43.0091 23.7286 43.2589C23.7043 43.4755 23.7873 43.6902 23.9509 43.834C24.1397 44 24.5684 44 25.4257 44H37.9413C39.8602 44 40.8196 44 41.5732 43.6776C42.5193 43.2729 43.2729 42.5193 43.6776 41.5732C44 40.8196 44 39.8602 44 37.9413C44 37.2957 44 36.9729 43.9294 36.6722C43.8407 36.2944 43.6706 35.9405 43.431 35.6352C43.2403 35.3923 42.9883 35.1906 42.4841 34.7873L38.7544 31.8036C38.2499 31.3999 37.9976 31.1981 37.7197 31.1268C37.4748 31.064 37.2172 31.0722 36.9767 31.1503C36.7039 31.2389 36.4648 31.4562 35.9867 31.8909Z",
    stroke: "#475467",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportImage);
export default __webpack_public_path__ + "static/media/import-image.c087bded6bff2ded12805983d8dc8304.svg";
export { ForwardRef as ReactComponent };